<template>
  <div
    class="c-input"
    :style="wrapperStyle"
    @mouseenter="hover = true"
    @mouseleave="hover = false"
  >
    <input
      ref="input"
      class="_input"
      :style="inputStyle"
      :disabled="disabled"
      :placeholder="placeholder"
      :type="type"
      :value="value"
      @input="handleInput"
      @change="change"
      @focus="focused = true"
      @blur="blur"
    >
  </div>
</template>

<script>
export default {
  name: 'CInput',
  props: {
    value: {
      type: String,
      default: '',
    },
    placeholder: {
      type: String,
      default: '',
    },
    autocomplete: {
      type: String,
      default: '',
    },
    size: {
      type: String,
      default: '',
    },
    type: {
      type: String,
      default: '',
    },
    showBorder: {
      type: Boolean,
      default: false,
    },
    showBackground: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    showOutline: {
      type: Boolean,
      default: false,
    },
    forceShowOutline: {
      type: Boolean,
      default: false,
    },
    autofocus: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['update:value', 'change'],
  data() {
    return { focused: false, hover: false };
  },
  computed: {
    inputStyle() {
      return {
        'font-size': 'inherit',
        fontWeight: 'inherit',
        'line-height': 'inherit',
        border: 'none',
        background: 'none',
        width: '100%',
        height: '100%',
        display: 'block',
        resize: 'none',
        padding: '0px',
        outline: 0,
      };
    },
    wrapperStyle() {
      const middlewares = [
        this.resizer,
        this.outliner,
        this.makeBackground,
      ];
      let res = {
        display: 'flex',
        'align-items': 'center',
        position: 'relative',
        'border-radius': '4px',
        cursor: 'text',
      };
      middlewares.forEach((m) => {
        res = m(res);
      });
      return res;
    },
  },
  methods: {
    blur() {
      this.focused = false;
    },
    change(event) {
      this.$emit('change', event.target.value);
    },
    handleInput(event) {
      this.$emit('update:value', event.target.value);
    },
    makeBackground(style) {
      if (this.showBackground || this.hover) {
        return {
          ...style,
          background: 'rgba(242, 241, 238, 0.6)',
        };
      }

      return { ...style };
    },
    outliner(style) {
      if (this.forceShowOutline || (this.showOutline && this.focused)) {
        return {
          ...style,
          border: `1px solid ${this.$colors.blue.base}`,
          boxShadow: '0 0 0 2px rgb(59 177 207 / 20%)',
        };
      }

      if (this.showBorder) {
        return {
          ...style,
          border: `1px solid ${this.$colors.grey.lighten3}`,
        };
      }

      return style;
    },
    resizer(style) {
      if (this.size === 'small') {
        return {
          ...style,
          height: '2.8rem',
          lineHeight: 1.2,
          padding: '0 8px',
        };
      }
      return {
        ...style,
        padding: '0px 10px',
        height: '3.2rem',
      };
    },
  },
  created() {
    if (this.autofocus) {
      this.$nextTick(() => {
        this.$refs.input.focus();
      });
    }
  },
};
</script>

<style
    scoped
    lang="scss"
    type="text/scss"
>
  .c-input {
    ._input::placeholder {
      color: map_get($grey, 'lighten-2');
    }
  }
</style>
